// All palette values should be valid hex color codes, since opacity is applied
// via appending the alpha hex value, i.e. `#rrggbbaa`

export var grey100 = '#F3F3F3';
export var grey200 = '#E6E6E6';
export var grey300 = '#D9D9D9';
export var grey400 = '#C8C8C8';
export var grey500 = '#B1B1B1';
export var grey600 = '#989898';
export var grey700 = '#767676';
export var grey800 = '#555555';
export var grey900 = '#171717';
export var blue100 = '#E1F4FF';
export var blue500 = '#7DC7FF';
export var blue600 = '#3894FF';
export var blue700 = '#1C69F2';
export var blue800 = '#0045DB';
export var blue900 = '#003894';
export var green100 = '#F2FFEF';
export var green500 = '#ABF091';
export var green600 = '#8FDE6B';
export var green700 = '#78C736';
export var green800 = '#61B024';
export var green900 = '#4A9912';
export var orange100 = '#FFF1E8';
export var orange500 = '#FFD5B8';
export var orange600 = '#FF8B38';
export var orange700 = '#F96800';
export var orange800 = '#D15700';
export var orange900 = '#A34400';
export var red100 = '#FFE4E4';
export var red500 = '#FFD1D1';
export var red600 = '#FF7373';
export var red700 = '#FF3B3B';
export var red800 = '#EB0A0A';
export var red900 = '#AB0000';
export var teal100 = '#BDF0ED';
export var teal400 = '#85E3E5';
export var teal500 = '#36C2CC';
export var teal600 = '#1C9CAD';
export var teal700 = '#05758A';
export var teal800 = '#005463';
export var teal900 = '#003D48';
export var purple100 = '#E3D6FF';
export var purple500 = '#CCADFF';
export var purple600 = '#AD73FA';
export var purple700 = '#8F3BF2';
export var purple800 = '#691CC2';
export var purple900 = '#452170';
export var yellow100 = '#FAF2C4';
export var yellow500 = '#FFE385';
export var yellow600 = '#FFD652';
export var yellow700 = '#FAC91F';
export var yellow800 = '#EBAD00';
export var yellow900 = '#D69600';
export var white = '#FFFFFF';
export var black = '#000000';